/*----------------------------------
- SALES GATEWAY CONTRACT
----------------------------------*/

/**
 * @docs docs/features/sales-page
 * @adr  ADR-0067
 *
 * Website gateway in front of `Product.Sales.LookupWord`: it validates the word, answers `gate`
 * from its day cookie without a Product call, and hashes the visitor (the closest proxy's address
 * and the UTC day) so Product can hold one real lookup per visitor per day. The literals live
 * here because the route compiler only accepts app-local static path expressions.
 */
export const SALES_LOOKUP_GATEWAY_PATH = '/api/website/sales/lookup';

/** The day cookie: the UTC day of the visitor's last real lookup. */
export const SALES_LOOKUP_COOKIE = 'ud_sales_lookup';

/** The full Markdown mirror (`SALES_FULL_MARKDOWN_PATH` in the shared contract). */
export const SALES_MARKDOWN_ROUTE_PATH = '/sales.md';
